export const SET_SOLICITUD_ID = 'SET_SOLICITUD_ID';

export const ADD_AUTORIZACION_LISTA_SOLICITUDES = 'ADD_AUTORIZACION_LISTA_SOLICITUDES';
export const SET_LISTADO_SOLICITUDES = 'SET_LISTADO_SOLICITUDES';
export const REFRESCAR_ULTIMAS_AUTORIZACIONES = 'REFRESCAR_ULTIMAS_AUTORIZACIONES';
export const REFRESCAR_ULTIMAS_AUTORIZACIONES_INICIO =
  'REFRESCAR_ULTIMAS_AUTORIZACIONES_INICIO';
export const REFRESCAR_ULTIMAS_AUTORIZACIONES_ERROR =
  'REFRESCAR_ULTIMAS_AUTORIZACIONES_ERROR';
export const CANCELAR_AUTORIZACION = 'CANCELAR_AUTORIZACION';

export const ERROR_AUTORIZACIONES_POST = 'ERROR_AUTORIZACIONES_POST';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const TRY_LOGIN = 'TRY_LOGIN';
export const TRY_LOGIN_SUCCESS = 'TRY_LOGIN_SUCCESS';
export const TRY_LOGIN_FAILED = 'TRY_LOGIN_FAILED';

export const RENOVAR_TOKEN = 'RENOVAR_TOKEN';
export const RENOVAR_TOKEN_SUCCESS = 'RENOVAR_TOKEN_SUCCESS';
export const RENOVAR_TOKEN_FAILED = 'RENOVAR_TOKEN_FAILED';

export const SET_EXPIRANDO = 'SET_EXPIRANDO';
export const SET_PERMISOCC = 'SET_PERMISOCC';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const RESET_STATES = 'RESET_STATES';

export const SET_BUSQUEDA = 'SET_BUSQUEDA';
export const RESET_BUSQUEDA = 'RESET_BUSQUEDA';

export const ERROR_BUSQUEDA_SERVICIOS = 'ERROR_BUSQUEDA_SERVICIOS';
export const SET_MENSAJE_RANGO = 'SET_MENSAJE_RANGO';

export const SET_SERVICIOS_IDA = 'SET_SERVICIOS_IDA';
export const SET_SERVICIOS_VUELTA = 'SET_SERVICIOS_VUELTA';
export const FILTRAR_SERVICIOS = 'FILTRAR_SERVICIOS';

export const SET_HORA_HAPROX_VUELTA = 'SET_HORA_HAPROX_VUELTA';
export const SET_VIAJE_VUELTA_ACTIVO = 'SET_VIAJE_VUELTA_ACTIVO';

export const SET_SERVICIO_IDA_SELECTED = 'SET_SERVICIO_IDA_SELECTED';
export const SET_SERVICIO_VUELTA_SELECTED = 'SET_SERVICIO_VUELTA_SELECTED';
